import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

// The mock's "Verified" glyph: a 14px stroke check in the success green,
// inline before the word. State, not a pill.
const FinCheck = () => (
  <CheckIcon className="h-3.5 w-3.5 shrink-0 stroke-[2.2] text-fin-green" aria-hidden="true" />
);

export default FinCheck;
